
import React, {useContext, useEffect, useRef} from "react";
import classnames from "classnames";
// reactstrap components
import {
    Input,
    InputGroupAddon,
    InputGroupText,
    InputGroup,
    Row,
    Col,
    CardHeader,Card, CardBody, Button, FormGroup
} from "reactstrap";
import NotificationAlert from "react-notification-alert";
import { UserLoginContext } from "../../context/UserLoginContext";
import { QuestionsContext } from "../../context/QuestionsContext";
import {useHistory} from "react-router-dom";
import SweetAlert from "react-bootstrap-sweetalert";
import rest from "../../API/api";
import { authenticatedFetch } from "../../services/authService";

const EditQuestion = () => {
    // eslint-disable-next-line
    const [questionsState, setQuestionsState] = useContext(QuestionsContext);
    const [userState, setUserState] = useContext(UserLoginContext);
    const notificationAlertRef = useRef(null);
    const [title, settitle] = React.useState(questionsState.theQuestion.Title);
    const [titleState, settitleState] = React.useState("");
    const [titleFocus, settitleFocus] = React.useState("");
    // eslint-disable-next-line
    const [question, setquestion] = React.useState(questionsState.theQuestion.Question);
    const [questionState, setquestionState] = React.useState("");
    const [questionFocus, setquestionFocus] = React.useState("");
    // eslint-disable-next-line
    const [initialValue, setinitialValue] = React.useState(questionsState.theQuestion.Value);
    const [initialValueFocus, setinitialValueFocus] = React.useState("");
    const [initialValueState, setinitialValueState] = React.useState("has-success");
    // eslint-disable-next-line
    const [placeholder, setplaceholder] = React.useState(questionsState.theQuestion.PlaceHolder);
    const [placeholderFocus, setplaceholderFocus] = React.useState("");
    const [placeholderState, setplaceholderState] = React.useState("has-success");
    // eslint-disable-next-line
    const [questiontype, setquestiontype] = React.useState(questionsState.theQuestion.Type);
    const [questiontypeFocus, setquestiontypeFocus] = React.useState("");
    const [questiontypeState, setquestiontypeState] = React.useState("has-success");

    const [alert, setalert] = React.useState(null);
    const history = useHistory();

    const stateFunctions = {
        settitleState: (value) => settitleState(value),
        settitle: (value) => settitle(value),
        setquestionState: (value) => setquestionState(value),
        setquestion: (value) => setquestion(value),
        setinitialValueState: (value) => setinitialValueState(value),
        setinitialValue: (value) => setinitialValue(value),
        setplaceholderState: (value) => setplaceholderState(value),
        setplaceholder: (value) => setplaceholder(value),
        setquestiontypeState: (value) => setquestiontypeState(value),
        setquestiontype: (value) => setquestiontype(value),
    };

    useEffect(() => {
        //console.log(questionsState.theQuestion);
        settitleState("has-success");
        setquestionState("has-success");
    }, []);

    // function that verifies if a string has a given length or not
    const verifyLength = (value, length) => {
        if (value.length >= length) {
            return true;
        }
        return false;
    };
    // function that verifies if value contains only numbers
    const verifyNumber = (value) => {
        var numberRex = new RegExp("^[0-9]+$");
        if (numberRex.test(value)) {
            return true;
        }
        return false;

    };
    const change = (event, stateName, type, stateNameEqualTo, maxValue) => {
        switch (type) {
            case "length":
                if (verifyLength(event.target.value, stateNameEqualTo)) {
                    stateFunctions["set" + stateName + "State"]("has-success");
                } else {
                    stateFunctions["set" + stateName + "State"]("has-danger");
                }
                stateFunctions["set" + stateName](event.target.value);
                break;
            case "number":
                if (verifyNumber(event.target.value, stateNameEqualTo)) {
                    stateFunctions["set" + stateName + "State"]("has-success");
                } else {
                    stateFunctions["set" + stateName + "State"]("has-danger");
                }
                stateFunctions["set" + stateName](event.target.value);
                break;
            default:
                break;
        }

    };
    /*eslint-disable-next-line*/
    const isValidated = () => {
        if (
            titleState === "has-success" &&
            questionState === "has-success" &&
            questiontypeState === "has-success"
        ) {
            return true;
        } else {
            if (titleState !== "has-success") {
                settitleState("has-danger");
            }
            if (questionState !== "has-success") {
                setquestionState("has-danger");
            }
            if (questiontypeState !== "has-success") {
                setquestiontypeState("has-danger");
            }
            return false;
        }
    };

    const _editQuestionAlert = async () => {
        //console.log("email to delete:" + email);
        //debugger;
        setalert(
            <SweetAlert
                warning
                showCancel
                confirmBtnText="Yes, save it!"
                confirmBtnBsStyle="info"
                cancelBtnBsStyle="default"
                title="Are you sure?"
                style={{display: "block"}}
                onConfirm={() => {
                    _edit_question();
                    setalert(null);
                }}
                onCancel={() =>  {
                    setalert(null);
                }}
            >
                Are you sure you want to save this question?
            </SweetAlert>
        );
    };

    const notify = (type, message) => {
        const options = {
            place: "tc",
            message: <div>{message}</div>,
            type: type,
            icon: "tim-icons icon-bell-55",
            autoDismiss: 5,
        };
        notificationAlertRef.current.notificationAlert(options);
    };

    const _edit_question = async () => {
        try {
            let tempURL = rest.questions + '/' + questionsState.theQuestion._id;

            const editQuestion = await authenticatedFetch(tempURL, {
                method: 'PUT',
                headers: {
                    'Content-Type': 'application/json;charset=UTF-8'
                },
                body: JSON.stringify({
                    Title: title,
                    Question: question,
                    Type: questiontype,
                    Value: initialValue,
                    PlaceHolder: placeholder,
                }),
            });

            if (!editQuestion.ok) {
                const errorData = await editQuestion.json().catch(() => ({}));
                throw new Error(errorData.message || `Failed to update question (${editQuestion.status})`);
            }

            const editQuestionJSON = await editQuestion.json();
            setQuestionsState((prevquestionsState) => ({
                ...prevquestionsState,
                theQuestions: editQuestionJSON
            }));

            notify("success", "Question has been updated successfully!");
            setTimeout(() => {
                history.push("/admin/questions");
            }, 1000);
        } catch (error) {
            console.error('Error updating question:', error);
            notify("danger", error.message || 'Failed to update question.');
        }
    };

    if (userState.status) {
      return (
          <>
              <div className="rna-container">
                  <NotificationAlert ref={notificationAlertRef} />
              </div>
              <div className="content">
                  <Col md={8} className="ml-auto mr-auto">
                      <h2 className="text-center">Edit a Custom Event Question</h2>
                  </Col>

                  <Card>
                      <CardHeader>Question Information:</CardHeader>
                      <CardBody>
                          <Row>
                              <Col md={5} mdOffset={1}>
                                  <FormGroup className={`has-label ${titleState}`}>
                                      <label>Question Title *</label>
                                      <Input
                                          name="title"
                                          type="text"
                                          value={title}
                                          onChange={(e) => change(e, "title", "length",1)}
                                      />
                                      {titleState === "has-danger" ? (
                                          <label className="error">
                                              Please enter a valid question title.
                                          </label>
                                      ) : null}
                                  </FormGroup>
                              </Col>
                              <Col md={3} mdOffset={1}>
                                  <FormGroup className={`has-label ${questionState}`}>
                                      <label>The Question *</label>
                                      <Input
                                          name="question"
                                          type="text"
                                          value={question}
                                          onChange={(e) => change(e, "question", "length",1)}
                                      />
                                      {questionState === "has-danger" ? (
                                          <label className="error">
                                              Please enter a valid question.
                                          </label>
                                      ) : null}
                                  </FormGroup>
                              </Col>
                          </Row>
                          <Row>
                              <Col md={5} mdOffset={1}>
                                  <FormGroup className={`has-label ${initialValueState}`}>
                                      <label>Initial Value</label>
                                      <Input
                                          name="initialValue"
                                          type="text"
                                          value={initialValue}
                                          onChange={(e) => change(e, "initialValue", "length",1)}
                                      />
                                      {initialValueState === "has-danger" ? (
                                          <label className="error">
                                              Please enter a valid question initial value.
                                          </label>
                                      ) : null}
                                  </FormGroup>
                              </Col>
                              <Col md={3} mdOffset={1}>
                                  <FormGroup className={`has-label ${placeholderState}`}>
                                      <label>Placeholder Text</label>
                                      <Input
                                          name="placeholder"
                                          type="text"
                                          value={placeholder}
                                          onChange={(e) => change(e, "placeholder", "length",1)}
                                      />
                                      {placeholderState === "has-danger" ? (
                                          <label className="error">
                                              Please enter a placeholder text.
                                          </label>
                                      ) : null}
                                  </FormGroup>
                              </Col>
                          </Row>
                          <Row>
                              <Col md={5} mdOffset={1}>
                                  <InputGroup
                                      className={classnames(questiontypeState, {
                                          "input-group-focus": questiontypeFocus,
                                      })}
                                  >
                                      <InputGroupAddon addonType="prepend">
                                          <InputGroupText>
                                              Question Type * :
                                          </InputGroupText>
                                      </InputGroupAddon>

                                      <Input
                                          name="questiontype"
                                          type="select"
                                          id="questiontype"
                                          value={questiontype}
                                          onChange={(e) => change(e, "questiontype", "length", 1)}
                                          onFocus={(e) => setquestiontypeFocus(true)}
                                          onBlur={(e) => setquestiontypeFocus(false)}
                                      >
                                          <option value="String">String</option>
                                          <option value="Yes">Yes/No</option>
                                          <option value="Checkbox">Checkbox</option>
                                      </Input>
                                      {questiontypeState === "has-danger" ? (
                                          <label className="error">This field is required.</label>
                                      ) : null}
                                  </InputGroup>
                              </Col>
                          </Row>
                      </CardBody>
                  </Card>
                  <Card>
                  <CardBody>
                          <Row>
                              <Col md={1} mdOffset={1} xs={5} xsOffset={1}>
                                  <Button color="info" className="animation-on-hover" onClick={ async () => {
                                      if(isValidated()) {
                                          await _editQuestionAlert();
                                      }
                                  }}>Save
                                  </Button>
                              </Col>
                              <Col md={1} mdOffset={1} xs={5} xsOffset={1}>
                                  <Button color="danger" className="animation-on-hover" onClick={ async () => {
                                          let tURL = "/admin/questions";
                                          await history.push(tURL);
                                  }}>Cancel
                                  </Button>
                              </Col>
                          </Row>
                      </CardBody>
                  </Card>
                  {alert}
              </div>
          </>
      );
    }
    else {
        //alert("You must be logged in and have an active subscription to access this page!");
        history.push("/admin/dashboard");
        return(null);
    }
};
export default EditQuestion;
